import * as rest from './RestUtil';
import { getFunctionBaseUrl } from './RestUrls';
import { formatDateRange, IMonthValue } from '../util/DateUtils';

export interface ITransportSummaryCategory {
  km: number;
  eur: number;
  eurPct: number;
}

export interface ITransportSummaryDataCategory {
  Km: string;
  EUR: string;
  '%EUR': string;
}

export interface ITransportSummaryData {
  COLD: ITransportSummaryDataCategory;
  CE: ITransportSummaryDataCategory;
  CRT: ITransportSummaryDataCategory;
  LDA: ITransportSummaryDataCategory;
  SDA: ITransportSummaryDataCategory;
}

export interface ISortSummaryDataCategory {
  KG: number;
  EUR: number;
  'EUR/KG': number;
  SORT_CODES?: string[];
}

export interface ISortSummaryData {
  WEEE1: {
    'LDA': ISortSummaryDataCategory;
    'COLD': ISortSummaryDataCategory;
    'SCRAP': ISortSummaryDataCategory;
    'SOLARPANELS': ISortSummaryDataCategory;
  };
  WEEE2: {
    'SDA': ISortSummaryDataCategory;
    'SCRAP': ISortSummaryDataCategory;
  };
  WEEE3: {
    'ICT': ISortSummaryDataCategory;
    'MONITORS': ISortSummaryDataCategory;
    'SCRAP': ISortSummaryDataCategory;
  };
  WEEE4: {
    'CE': ISortSummaryDataCategory;
    'CRT': ISortSummaryDataCategory;
    'MUSIC': ISortSummaryDataCategory;
  };
  WEEE5: {
    'LAMPS': ISortSummaryDataCategory;
  };
  WEEE6: {
    'EL_TOOLS': ISortSummaryDataCategory;
  };
  WEEE7: {
    'TOYS': ISortSummaryDataCategory;
  };
  WEEE8: {
    'HEALTH': ISortSummaryDataCategory;
  };
  WEEE9: {
    'MONITORING_TOOLS': ISortSummaryDataCategory;
    'FIRE_ALARMS': ISortSummaryDataCategory;
  };
  "TOTAL_KG": number;
  "TOTAL_EUR": number;
}

/**
 * @param reportingPeriod "MM-YYYY"
 */
export const sendTransportsummaryReportData = async (reportingPeriod: string, json: any) => {
  const url = `${getFunctionBaseUrl()}/api/insertTransportsummary/${reportingPeriod}`
  const response = await rest.post(url, json);
  return response;
}

export const sendSortsummaryReportData = async (json: any) => {
  const url = `${getFunctionBaseUrl()}/api/insertSortsummary`
  const response = await rest.post(url, json);
  return response;
}

export const getSortsummaryData = async (sorterId: string, reportingTypes: string[], startDate: IMonthValue, endDate: IMonthValue) => {
  const period = formatDateRange(startDate, endDate);
  const url = `${getFunctionBaseUrl()}/api/getSortsummaryData/${sorterId}/${reportingTypes.join('+')}/${period}`
  return await rest.get(url);
}

export const getTransportsummaryData = async (startDate: IMonthValue, endDate: IMonthValue) => {
  const period = formatDateRange(startDate, endDate);
  const url = `${getFunctionBaseUrl()}/api/getTransportsummaryData/${period}`
  return await rest.get(url);
}